import { render } from "./NotesSection.vue?vue&type=template&id=09cf608e"
import script from "./NotesSection.vue?vue&type=script&lang=js"
export * from "./NotesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__